const data = {
	pathname: 'centaline',
	filename: 'poster_2',
	bgColor: '#f6f6f6',
	bgImg: 'bg.jpg',
	color: '#9d6252',
	posters: [
		{
			img: [{ logo: true, pic: 'img_01.jpg' }, 'img_02.jpg', 'img_03.jpg', 'img_04.jpg', 'img_05.jpg', 'img_06.jpg', 'img_07.jpg']
		},
		{
			tel: ['022-66684833', '022-66684866']
		},
		{
			form: {
				bg: 'rgba(182, 105, 87, 0.25)',
				radius: '8px'			
			}
		},
		{
			img: ['img_08.jpg', 'img_09.jpg', 'img_10.jpg', 'img_11.jpg', 'img_12.jpg', 'img_13.jpg', 'img_14.jpg', 'img_15.jpg', 'img_16.jpg', 'img_17.jpg', 'img_18.jpg']
		},
		{
			swiper: {}
		},
		{
			tel: ['022-66684866', '022-66684833']
		},
		{
			form: {
				bg: 'rgba(182, 105, 87, 0.25)',
				radius: '8px'
			}
		}
	]
};

export default data;
